import { CheckCircle2, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";

const checklistItems = [
  { label: 'Complete Your Profile', done: false },
  { label: 'RSVP to Your First Event', done: false },
  { label: 'Try the Buddy System', done: false },
  { label: 'Join a Herd', done: false },
  { label: 'Connect with Someone', done: false },
  { label: 'Attend Your First Event', done: false },
];

export const DemoFinale = () => {
  return (
    <Card className="p-5 bg-card/95 backdrop-blur-sm border-border/50 space-y-4">
      <div className="text-center space-y-2">
        <div className="w-14 h-14 mx-auto rounded-full bg-primary/20 flex items-center justify-center">
          <Sparkles className="w-7 h-7 text-primary" />
        </div>
        <h3 className="font-display text-lg font-semibold text-foreground">Your Checklist Awaits!</h3>
        <p className="text-sm text-muted-foreground">Complete these to unlock the full experience</p>
      </div>
      
      <div className="space-y-2">
        {checklistItems.map((item, index) => (
          <div 
            key={index}
            className={`flex items-center gap-3 p-2.5 rounded-lg transition-colors ${
              item.done ? 'bg-primary/10' : 'bg-muted/50'
            }`}
          >
            <CheckCircle2 
              className={`w-5 h-5 ${
                item.done ? 'text-primary' : 'text-muted-foreground/50'
              }`} 
            />
            <span className={`text-sm ${
              item.done ? 'text-foreground' : 'text-muted-foreground'
            }`}>
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};
